import React, {Component} from 'react'
import _Phone from 'zop-react-phone-number-input'

import 'zop-react-phone-number-input/rrui.css'
import 'zop-react-phone-number-input/style.css'
import './override.css'

class Phone extends Component {
  render () {
    let PhoneInput = _Phone
    return (
      <PhoneInput
        country='IN'
        placeholder='Enter your phone number'
        onChange={this.props.onChange}
        value={this.props.value}
        name='phone'
        required
      />
    )
  }
}

export default Phone
